import { ChangeDesignation } from './ChangeDesignation';

export default ChangeDesignation;
